import React, { useState } from 'react';
import {  Grid, List, ListItem, ListItemText, Typography } from '@mui/material';

interface RightSidebarProps {
  onMenuSelect: (menu: string) => void;
}

const RightSidebar: React.FC<RightSidebarProps> = ({ onMenuSelect }) => {
  const menuItems = ['CORBALAR', 'MEZELER', 'BALIKLAR', 'SALATALAR', 'ARA SICAKLAR', 'ANA YEMEKLER', 'ICECEKLER', 'TATLILAR'];
  
  const [selectedItem, setSelectedItem] = useState<string | null>(null); // Track the selected item
  
  const handleMenuClick = (item: string) => {
    setSelectedItem(item); // Update the selected item
    onMenuSelect(item); // Notify the parent component of the selection
  };

  return (
    <Grid sx={{ display: 'flex', flexDirection: 'column', height: '100vh', backgroundColor: '#f5f5f5', right: 0, boxShadow: '-3px 0px 5px rgba(0, 0, 0, 0.1)', padding: '10px' }}>
      <Typography variant="h6" sx={{ textAlign: 'center', mt: 2 }}>Menu</Typography>

      <List sx={{ marginTop: 0 }}>
        {menuItems.map((item, index) => (
          <ListItem
            button
            key={index}
            onClick={() => handleMenuClick(item)}
            sx={{
              backgroundColor: selectedItem === item ? '#9c27b0' : 'transparent', // Change color when selected
              color: selectedItem === item ? '#fff' : '#000', // Change text color when selected
              '&:hover': {
                backgroundColor: selectedItem === item ? '#9c27b0' : '#f0f0f0', // Hover effect
              },
            }}
          >
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>
    </Grid>
  );
};

export default RightSidebar;
